import ResourceVisualisationDialog from '../application-core/visualisation/ResourceVisualisationDialog2';
import HistoryViewer from '../core/HistoryViewer';
import { getGraphFromProject } from '../core/utils/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import TripleViewer from '../core/TripleViewer';
import DataOptions from '../core/DataOptions';
import ObjectPropertyDetail from './ObjectPropertyDetail';
import DatatypePropertyDetail from './DatatypePropertyDetail';
import AnnotationPropertyDetail from './AnnotationPropertyDetail';
import ResourceSummaryDetail from './ResourceSummaryDetail';
import { OWL_OBJECT_CONFIGURATION, VIZ_CLASSES } from './constants';

class PropertyData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  render() {

    const { propertyIRI, onDeleteProperty, project, ontologyIRI, searchClass, buildLink, viewLang, excludeDeprecated,
      hiddenProps, availableAnnotationProperty } = this.props;
    const { view } = this.state;
    const projectGraph = getGraphFromProject(project);

    return (
      <ProjectConsumer>
        {({ defaultLang }) => (
          <div>
            <DataOptions
              handleNotAvailable={true}
              graph={projectGraph}
              id={propertyIRI}
              changeView={this.changeView}
              view={this.state.view} historyOption={true} />
            <div style={{ float: 'right', width: 'calc(100% - 60px)', marginBottom: '20px', paddingLeft: '10px' }}>
              <ResourceSummaryDetail
                handleNotAvailable={true}
                allowIRIchange={false}
                defaultLang={defaultLang}
                viewLang={viewLang}
                graph={projectGraph}
                id={propertyIRI}
                canDeprecate={true}
                onDeleteResource={onDeleteProperty}
                additionalViews={
                  <ResourceVisualisationDialog
                    defaultLang={defaultLang}
                    objectPropertyConfiguration={OWL_OBJECT_CONFIGURATION}
                    displayClasses={VIZ_CLASSES}
                    viewLang={viewLang}
                    sourceNode={propertyIRI}
                    graph={projectGraph} />
                }
                permission="https://grafsync.graphifi.com/schema/om-entitlement/editOntology" />
              {view === 0 && searchClass === "http://www.w3.org/2002/07/owl#ObjectProperty" &&
                <ObjectPropertyDetail
                  handleNotAvailable={true}
                  defaultLang={defaultLang}
                  graph={projectGraph}
                  viewLang={viewLang}
                  expectedTypes={["ObjectProperty"]}
                  excludeDeprecated={excludeDeprecated}
                  hiddenProps={hiddenProps}
                  ontologyIRI={ontologyIRI}
                  buildLink={buildLink}
                  availableAnnotationProperty={availableAnnotationProperty}
                  project={project}
                  id={propertyIRI}
                  onDeleteProperty={onDeleteProperty} />}
              {view === 0 && searchClass === "http://www.w3.org/2002/07/owl#DatatypeProperty" &&
                <DatatypePropertyDetail
                  handleNotAvailable={true}
                  defaultLang={defaultLang}
                  expectedTypes={["DatatypeProperty"]}
                  graph={projectGraph}
                  viewLang={viewLang}
                  excludeDeprecated={excludeDeprecated}
                  hiddenProps={hiddenProps}
                  ontologyIRI={ontologyIRI}
                  buildLink={buildLink}
                  availableAnnotationProperty={availableAnnotationProperty}
                  project={project}
                  id={propertyIRI}
                  onDeleteProperty={onDeleteProperty} />}
              {view === 0 && searchClass === "http://www.w3.org/2002/07/owl#AnnotationProperty" &&
                <AnnotationPropertyDetail
                  handleNotAvailable={true}
                  defaultLang={defaultLang}
                  expectedTypes={["AnnotationProperty"]}
                  graph={projectGraph}
                  viewLang={viewLang}
                  excludeDeprecated={excludeDeprecated}
                  hiddenProps={hiddenProps}
                  ontologyIRI={ontologyIRI}
                  availableAnnotationProperty={availableAnnotationProperty}
                  buildLink={buildLink}
                  project={project}
                  id={propertyIRI}
                  onDeleteProperty={onDeleteProperty} />}
              {view === 1 &&
                <TripleViewer handleNotAvailable={true} id={propertyIRI} graph={projectGraph} />}
              {view === 4 &&
                <HistoryViewer handleNotAvailable={true} id={propertyIRI} graph={projectGraph} />}
            </div>
          </div>
        )}
      </ProjectConsumer>
    );
  }

}

PropertyData.propTypes = {
  buildLink: PropTypes.func.isRequired,
  searchClass: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  excludeDeprecated: PropTypes.bool,
  viewLang: PropTypes.string,
  hiddenProps: PropTypes.array,
  propertyIRI: PropTypes.string.isRequired,
  ontologyIRI: PropTypes.string.isRequired,
  onDeleteProperty: PropTypes.func.isRequired,
  availableAnnotationProperty: PropTypes.array
};

export default PropertyData;